
import DefaultConstants from '../data/Constants';
import { createHashHistory } from 'history/cjs/history.min';


const history = createHashHistory({
    basename: DefaultConstants.publicURL ?? '/'
});


export {
    history
}